import { createContext } from 'react'

export interface ConfirmOptions {
  message: string
  confirmLabel?: string
  cancelLabel?: string
  /** Styles the action as destructive. Use for anything that loses data. */
  destructive?: boolean
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>

export const ConfirmContext = createContext<ConfirmFn | null>(null)
